var ColorCode = /*#__PURE__*/function (ColorCode) {
  ColorCode["Primary"] = "primary-default";
  ColorCode["Success"] = "success-default";
  ColorCode["Expose"] = "expose-default";
  ColorCode["Warning"] = "warning-default";
  ColorCode["PrimaryLight"] = "primary-light";
  ColorCode["SuccessLight"] = "success-light";
  ColorCode["ExposeLight"] = "expose-light";
  ColorCode["WarningLight"] = "warning-light";
  ColorCode["PrimaryMedium"] = "primary-medium";
  ColorCode["SuccessMedium"] = "success-medium";
  ColorCode["ExposeMedium"] = "expose-medium";
  ColorCode["WarningMedium"] = "warning-medium";
  ColorCode["PrimaryDark"] = "primary-dark";
  ColorCode["SuccessDark"] = "success-dark";
  ColorCode["ExposeDark"] = "expose-dark";
  ColorCode["WarningDark"] = "warning-dark";
  ColorCode["GreyscaleLevel1"] = "greyscale-level-1";
  ColorCode["GreyscaleLevel2"] = "greyscale-level-2";
  ColorCode["GreyscaleLevel3"] = "greyscale-level-3";
  ColorCode["GreyscaleLevel4"] = "greyscale-level-4";
  ColorCode["GreyscaleLevel5"] = "greyscale-level-5";
  ColorCode["GreyscaleLevel6"] = "greyscale-level-6";
  /**
   * @deprecated Use GreyscaleLevel6 instead.
   */
  ColorCode["GreyscaleLevel7"] = "greyscale-level-7";
  return ColorCode;
}({});
var Directions = /*#__PURE__*/function (Directions) {
  Directions["Vertical"] = "vertical";
  Directions["Horizontal"] = "horizontal";
  return Directions;
}({});

export { ColorCode, Directions };
//# sourceMappingURL=ui.js.map
